import { localizeIt } from "components/service/localize";

const parseStatusValue = (statusRaw) => {
    const [statusValue, statusLabel] = statusRaw ? statusRaw.split(":") : [];

    if (!statusValue) {
        return {};
    }

    if (statusValue === "collected") {
        return {
            value: "done",
            label: localizeIt("CRAFT.Status_Text_Done")
        };
    }

    return {
        value: statusValue,
        label: statusLabel || localizeIt(
            statusValue === "open"
                ? "CRAFT.Status_Text_Open"
                : "CRAFT.Status_Text_Done"
        )
    };
};

const trimValue = (value) => value ? value.trim() : "";
const toLikePattern = (value) => {
    const normalized = trimValue(value);

    return normalized ? `%${ normalized }%` : "";
};
const fromLikePattern = (value = "") => value.replace(/^%|%$/g, "");

export const collectGraphicsFilterFieldsConfig = {
    block: {
        filterGroup: "where",
        column: "BLOCK",
        operator: "LIKE",
        getValue: (value) => toLikePattern(value),
        getLabel: (value) => `${ localizeIt("GLOBAL.Card_Hero_Block") }: ${ trimValue(value) }`,
        getInitialValue: (item = {}) => item.value ? fromLikePattern(item.value) : null
    },
    craftStatus: {
        filterGroup: "whereCrafts",
        column: "STATUS",
        operator: "EQ",
        getValue: (value) => parseStatusValue(value).value,
        getLabel: (value) => parseStatusValue(value).label,
        getInitialValue: (item = {}) =>
            item.value && item.label ? `${ item.value }:${ item.label }` : null
    }
};

export const getCollectGraphicsInitialValues = (data) => {
    return Object.entries(collectGraphicsFilterFieldsConfig).reduce((acc, [key, config]) => {
        const currentItem = data[config.filterGroup][key];

        return {
            ...acc,
            [key]: config.getInitialValue(currentItem)
        };
    }, {});
};

export const getCollectGraphicsActiveFiltersCount = (values) => {
    return Object.entries(collectGraphicsFilterFieldsConfig).reduce((count, [key, config]) => {
        const value = config.getValue(values[key]);

        return value ? count + 1 : count;
    }, 0);
};

export const buildCollectGraphicsFilterState = (values, data) => {
    return Object.entries(collectGraphicsFilterFieldsConfig).reduce((acc, [key, config]) => {
        const value = config.getValue(values[key]);
        const nextItem = value ? {
            label: config.getLabel(values[key]),
            column: config.column,
            operator: config.operator,
            value
        } : {};

        return {
            ...acc,
            [config.filterGroup]: {
                ...acc[config.filterGroup],
                [key]: nextItem
            }
        };
    }, {
        ...data,
        where: {
            ...data.where
        },
        whereCrafts: {
            ...data.whereCrafts
        },
        activeFilters: getCollectGraphicsActiveFiltersCount(values)
    });
};
